console.log("this");
require("./_lazyload.js");
require("./mobile-menu.js");

// require('./_slideshow.js');
require("./_gallery.js");
require("./_calculator.js");
